import { useCallback } from 'react';
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 *
 * @see https://github.com/radix-ui/primitives/blob/ea7e5e3f24bca5b059df80f54f2cd8535090c99e/packages/react/compose-refs/src/composeRefs.tsx
 */
export function useComposedRefs(...refs) {
    return useCallback((node) => {
        refs.forEach((ref) => assignRef(ref, node));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}
export function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref != null) {
        ref.current = value;
    }
}
//# sourceMappingURL=useComposedRefs.js.map